module.exports = __webpack_public_path__ + "static/habitica-4118f105986333cb986adae7a4c5b652.png";